import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';

import { EmployeeService, EmployeeId } from '../../services/employee.service';
import { CheckClockService } from '../../services/check-clock.service';
import { SupervisorReportService } from '../../services/supervisor-report.service';
import { CarrierReportService } from '../../services/carrier-report.service';
import { PrompterReportService } from '../../services/prompter-report.service';
import { AssistanceReportService } from '../../services/assistance-report.service';
import { ApprovedAssistanceService } from '../../services/approved-assistance.service';
import { DepartmentService } from '../../services/department.service';
import { LogService } from '../../services/log.service';
import { AuthService } from '../../services/auth.service';
import { PermissionService } from '../../services/permission.service';

import { Utils } from '../../util';
import { Router } from '@angular/router';
import { NewPrompterReportService } from '../../services/new-prompter-report.service';
import { SecurityReportService } from '../../services/security-report.service';

@Component({
    selector: 'app-display-assistance-report',
    templateUrl: './display-assistance-report.component.html',
    styleUrls: ['./display-assistance-report.component.css', '../../app.component.css']
})

export class DisplayAssistanceReportComponent implements OnInit {
    allowed: boolean = false;
    permission: any = {};

    readonly IS_OK = 1;
    readonly NOT_REPORTED = 0;
    readonly NOT_APPEAR = -1;
    readonly NOT_APPLY = -2;
    readonly IS_APPROVED = 2;

    readonly COMPLETE = true;
    readonly INCOMPLETE = false;

    readonly NOT_REPORTED_TEXT = 'No Reportado';
    readonly NOT_APPEAR_TEXT = 'No Aparece';
    readonly NOT_APPLY_TEXT = 'N / A';
    readonly IS_APPROVED_TEXT = 'Aprobada';

    pickadateParams = Utils.pickadateParamsNoBlank();

    _review = '';

    employeesArriveCarrier = [];

    userSession: string;

    runningFlag = false;
    loadText = 0;

    garSubs: any;
    geSubs: any;
    gccbrdSubs: any;
    gsrbrsSubs: any;
    gcrbrdSubs: any;
    gprbrdSubs: any;
    gareSubs: any;
    gaabrdSubs: any;

    reportDate: string;
    captureUser: string;
    generationDate: any;
    employeesData: any;

    globalActions = new EventEmitter<string|MaterializeAction>();
    globalActionsRunning = new EventEmitter<string|MaterializeAction>();

    data: Array<any>;
    rows: Array<any> = [];
    columns: Array<any> = [
        { title: '', className: 'center',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
            { name: 'info', title: '', styleIcon: 'account_box', action: 'onInfo',
              styleClass: 'btn-floating btn waves-effect light-blue lighten-1' }
        ] } },
        { title: 'Llave', name: 'employeeFolio', sort: 'asc'},
        { title: 'Empleado', name: 'employeeName', sort: 'asc' },
        { title: 'Reloj Checador', name: 'checkClock', sort: false },
        { title: 'Supervisor', className: 'center', name: 'supervisor', sort: false },
        { title: 'Seguridad', className: 'center', name: 'security', sort: false },
        { title: 'Transportista', className: 'center', name: 'carrier', sort: false },
        { title: 'Apuntador', className: 'center',  name: 'prompter', sort: false },
        { title: '', className: 'center',  name: 'name', sort: false },
        { title: 'Estatus', className: 'center',  name: 'icon', sort: false }
    ];

    page = 1;
    itemsPerPage = 20;
    maxSize = 5;
    numPages = 1;
    length = 0;
    config: any = {
        paging: true,
        sorting: { columns: this.columns },
        filtering: { filterString: '' },
        api: {
            onInfo: this.onInfo.bind(this),
        }
    };

    filterVal: number;

    showAssistanceReport = false;

    // Approve inconsistencies
    inconsistency: any;

    reportDateCcVal = '';
    employeeNameCcVal = '';
    userNameCcVal = '';
    isCheckClockPending = false;
    checkClockApproveForm: FormGroup;

    reportDateSupVal = '';
    employeeNameSupVal = '';
    userNameSupVal = '';
    isSupervisorPending = false;
    supervisorApproveForm: FormGroup;

    reportDateSecVal = '';
    employeeNameSecVal = '';
    userNameSecVal = '';
    isSecurityPending = false;
    securityApproveForm: FormGroup;

    reportDateCarVal = '';
    employeeNameCarVal = '';
    userNameCarVal = '';
    isCarrierPending = false;
    carrierApproveForm: FormGroup;

    reportDatePromVal = '';
    employeeNamePromVal = '';
    userNamePromVal = '';
    isPrompterPending = false;
    prompterApproveForm: FormGroup;

    modalActions = new EventEmitter<string|MaterializeAction>();
    modalParams = [ {
        dismissible: false,
        complete: function() {
            // console.log('Modal : Close');
        }
    } ];

    readonly TYPE_CHECK_CLOCK = 1;
    readonly TYPE_SUPERVISOR = 2;
    readonly TYPE_CARRIER = 3;
    readonly TYPE_PROMPTER = 4;
    readonly TYPE_SECURITY = 5;


    closedAssistanceReport = true;

    permissions = [];
    permissionsSubs: any;

    validatingFlag = false;
    createAction = false;
    updateAction = false;

    gdSubs: any;
    departmentsInfo = [];
    employeesInfo = [];

    infoModalActions = new EventEmitter<string|MaterializeAction>();
    infoModalParams = [ {
        dismissible: false,
        complete: function() {
            // console.log('Modal : Close');
        }
    } ];

    employeeInfo: any = [];
    igeSubs: any;
    igdSubs: any;
    igcSubs: any;

    defaultDepartmentInfo = [true, true, true, true /* New Security Additions */];
    /* employees = {}; */
    constructor(
        private employeeService: EmployeeService,
        private checkClockService: CheckClockService,
        private supervisorReportService: SupervisorReportService,
        private carrierReportService: CarrierReportService,
        private prompterReportService: PrompterReportService,
        private newPrompterReportService: NewPrompterReportService,
        private securityReportService: SecurityReportService,
        private service: AssistanceReportService,
        private approvedAssistanceService: ApprovedAssistanceService,
        private departmentService: DepartmentService,
        private formBuilder: FormBuilder,
        private logService: LogService,
        private authService: AuthService,
        private permissionService: PermissionService,
        private router: Router
    ) {
        let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
            permissionsSubs.unsubscribe();
            this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
            if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
            else this.allowed = true;
        });

        this.userSession = this.authService.currentUser;

        this.gdSubs = this.departmentService.getDepartments().subscribe(tempDepartments => {
            this.gdSubs.unsubscribe();

            for (const idx in tempDepartments) {
                this.departmentsInfo[tempDepartments[idx].id$] = [
                    tempDepartments[idx].applyInPrompterReport,
                    tempDepartments[idx].applyInSupervisorReport,
                    tempDepartments[idx].applySecurityReport,
                    tempDepartments[idx].applyInCheckClock,
                ];
            }
        });

        /* let sub = this.employeeService.getEmployees().subscribe((employees: EmployeeId[]) => {
            sub.unsubscribe();
            this.employees = employees.reduce((acc, cur) => ({[cur.id]: cur}), {});
        }); */
    }

    ngOnInit() {
        this.checkClockApproveForm = this.formBuilder.group({
            reportDateCc: ['', Validators.required],
            employeeNameCc: ['', Validators.required],
            userNameCc: ['', Validators.required]
        });

        this.supervisorApproveForm = this.formBuilder.group({
            reportDateSup: ['', Validators.required],
            employeeNameSup: ['', Validators.required],
            userNameSup: ['', Validators.required]
        });

        this.securityApproveForm = this.formBuilder.group({
            reportDateSec: ['', Validators.required],
            employeeNameSec: ['', Validators.required],
            userNameSec: ['', Validators.required]
        });

        this.carrierApproveForm = this.formBuilder.group({
            reportDateCar: ['', Validators.required],
            employeeNameCar: ['', Validators.required],
            userNameCar: ['', Validators.required]
        });

        this.prompterApproveForm = this.formBuilder.group({
            reportDateProm: ['', Validators.required],
            employeeNameProm: ['', Validators.required],
            userNameProm: ['', Validators.required]
        });
    }

    @Input()
    set review(review: string) {
        console.log('Validating date');

        this._review = review;

        this.createAction = false;
        this.updateAction = false;

        this.validatingFlag = true;

        this.data = [];
        this.length = this.data.length;
        this.onChangeTable(this.config);

        this.reportDate = '';
        this.captureUser = '';
        this.generationDate = '';
        this.employeesData = [];
        this.showAssistanceReport = false;

        if (this._review !== undefined && this._review !== '') {
            const self = this;

            this.garSubs = this.service.getAssistanceReport(this._review).subscribe(assistanceReportObj => {
                this.garSubs.unsubscribe();

                if (assistanceReportObj !== null) {
                    this.getAssistanceReport(this._review);
                    self.updateAction = true;
                    self.validatingFlag = false;
                } else {
                    self.createAction = true;
                    self.validatingFlag = false;
                }
            });
        } else {
            this.globalActions.emit('toast');
            this.validatingFlag = false;
        }
    }

    get review(): string {
        return this._review;
    }
    
    createReport() {
        if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
        if (this.runningFlag === false) {
            if (this._review !== undefined && this._review !== '') {
                console.log('Create assistance report');

                this.runningFlag = true;

                this.loadCheckClockLoads();
            } else {
                this.globalActions.emit('toast');
            }
        } else {
            this.globalActionsRunning.emit('toast');
        }
    }

    updateReport() {
        if(!this.permission.createAction || !this.permission.updateAction) return toast('No tiene los permisos para actualizar.', 2000);
        if (this.runningFlag === false) {
            if (this._review !== undefined && this._review !== '') {
                console.log('Update assistance report');

                this.data = [];
                this.length = this.data.length;
                this.onChangeTable(this.config);

                this.reportDate = '';
                this.captureUser = '';
                this.generationDate = '';
                this.employeesData = [];
                this.showAssistanceReport = false;

                this.runningFlag = true;

                this.service.delAssistanceReport(this._review).then(res => {
                    console.log('Deleted old assistance report');

                    this.loadCheckClockLoads();
                });
            } else {
                this.globalActions.emit('toast');
            }
        } else {
            this.globalActionsRunning.emit('toast');
        }
    }

    loadCheckClockLoads() {
        console.log('Start');
        const employees: any[] = [];

        this.geSubs = this.employeeService.getEmployees().subscribe(tempEmployeesData => {
            this.geSubs.unsubscribe();
            console.log('Get employees data');

            this.loadText = 1;

            for (const idxEd in tempEmployeesData) {
                const itemId = tempEmployeesData[idxEd].id$.toString();

                employees[itemId] = {
                    employeeId: itemId,
                    employeeDepartmentId: (tempEmployeesData[idxEd].departmentId) ? tempEmployeesData[idxEd].departmentId : '',
                    employeeName: tempEmployeesData[idxEd].name + ' ' + tempEmployeesData[idxEd].lastName,
                    employeeFolio: tempEmployeesData[idxEd].internalKey,
                    checkClockId: [],
                    checkClockStatus: this.NOT_REPORTED,
                    checkClockValue: '',
                    supervisorId: [],
                    supervisorStatus: this.NOT_REPORTED,
                    supervisorValue: '',
                    supervisorActivity: '',
                    supervisorAdvance: 0,
                    securityId: [],
                    securityStatus: this.NOT_REPORTED,
                    securityValue: '',
                    carrierId: [],
                    carrierEmployee: [],
                    carrierStatus: this.NOT_REPORTED,
                    carrierValue: '',
                    carrierIsForeign: tempEmployeesData[idxEd].transportArrive == 3.5,
                    prompterId: [],
                    prompterStatus: this.NOT_REPORTED,
                    prompterValue: '',
                    status: this.INCOMPLETE
                };
                //console.log(employees[itemId]);

                if (Math.floor(tempEmployeesData[idxEd].transportArrive) === 3) {
                    this.employeesArriveCarrier.push(tempEmployeesData[idxEd].id$);
                }

                this.employeesInfo[tempEmployeesData[idxEd].id$] = [
                    tempEmployeesData[idxEd].applyInPrompterReport,
                    tempEmployeesData[idxEd].applyInSupervisorReport,
                    tempEmployeesData[idxEd].applySecurityReport,
                    tempEmployeesData[idxEd].applyInCheckClock,
                ];
            }

            this.gccbrdSubs = this.checkClockService.getCheckClocksByRegistrationDate(this._review).subscribe(tempCheckClocks => {
                this.gccbrdSubs.unsubscribe();
                console.log('Get check clock data');

                this.loadText = 2;

                const reviewDate = Utils.convertDatefromISOStringtoObject(this._review);

                if (tempCheckClocks.length > 0) {
                    for (const idxCc in tempCheckClocks) {
                        if (tempCheckClocks[idxCc].employeeId !== '') {
                            const employeeId = tempCheckClocks[idxCc].employeeId.toString();

                            if (employees[employeeId] !== undefined) {
                                employees[employeeId].checkClockId.push(tempCheckClocks[idxCc].id$);
                                employees[employeeId].checkClockStatus = this.IS_OK;
                                employees[employeeId].checkClockValue = employees[employeeId].checkClockValue +
                                        (tempCheckClocks[idxCc].type === 0 ? 'E ' : tempCheckClocks[idxCc].type === 1 ? 'S ' : 'O ') +
                                        tempCheckClocks[idxCc].registrationTime + ' ' + ' ' + ' ';
                            }
                        }
                    }
                    
                    for (const item in employees) {
                        if (employees[item].checkClockStatus === this.NOT_REPORTED) {
                            if (this.employeesInfo[employees[item].employeeId][3] === true) {
                                if (employees[item].employeeDepartmentId === '') {
                                    employees[item].checkClockStatus = this.NOT_APPEAR;
                                } else {
                                    if ((this.departmentsInfo[employees[item].employeeDepartmentId] || this.defaultDepartmentInfo)[3] === true) {
                                        employees[item].checkClockStatus = this.NOT_APPEAR;
                                    } else {
                                        employees[item].checkClockStatus = this.NOT_APPLY;
                                    }
                                }
                            } else {
                                employees[item].checkClockStatus = this.NOT_APPLY;
                            }

                        }
                    }

                    this.loadSupervisorReport(employees, reviewDate);
                } else {
                    for (const item in employees) {
                        if (employees[item].checkClockStatus === this.NOT_REPORTED) {
                            if (this.employeesInfo[employees[item].employeeId][3] === false) {
                                employees[item].checkClockStatus = this.NOT_APPLY;
                            }

                            if (employees[item].employeeDepartmentId !== '') {
                                if ((this.departmentsInfo[employees[item].employeeDepartmentId] || this.defaultDepartmentInfo)[3] === false) {
                                    employees[item].checkClockStatus = this.NOT_APPLY;
                                }
                            }
                        }
                    }

                    this.loadSupervisorReport(employees, reviewDate);
                }
            });
        });
    }

    loadSupervisorReport(employees, reviewDate) {
        console.log(`loadSupervisorReport ${reviewDate}.`, reviewDate)
        this.gsrbrsSubs = this.supervisorReportService.getSupervisorReportsByReportDate(reviewDate).subscribe(tempSupervisorReports => {
            this.gsrbrsSubs.unsubscribe();
            console.log('Get supervisor data', tempSupervisorReports);

            this.loadText = 3;

            if (tempSupervisorReports.length > 0) {
                for (const idxSr in tempSupervisorReports) {
                    //console.log('Report : ' + idxSr);
                    const supervisorReportId = tempSupervisorReports[idxSr].id$;
                    const supervisorReportEmployees = tempSupervisorReports[idxSr].employees;

                    for (const idxSre in supervisorReportEmployees) {
                        const employeeId = supervisorReportEmployees[idxSre].employeeId.toString();

                        //if(employees[employeeId].employeeFolio === 8008) console.log('111', employees[employeeId]);
                        if (employees[employeeId] !== undefined) {
                            employees[employeeId].supervisorId.push(supervisorReportId);
                            employees[employeeId].supervisorStatus = this.IS_OK;
                            employees[employeeId].supervisorValue = employees[employeeId].supervisorValue +
                                    supervisorReportEmployees[idxSre].startTime + ' - ' +
                                    supervisorReportEmployees[idxSre].endTime + ' ';

                            if (supervisorReportEmployees[idxSre].advanceValue !== undefined && supervisorReportEmployees[idxSre].advanceValue !== "") {
                                employees[employeeId].supervisorActivity = supervisorReportEmployees[idxSre].activityId;
                                employees[employeeId].supervisorAdvance = supervisorReportEmployees[idxSre].advanceValue;
                            }
                        }
                    }
                }

                for (const item in employees) {
                    //if(employees[item].employeeFolio === 8008) console.log('112', employees[item], this.departmentsInfo);
                    //if(employees[item].employeeFolio === 1613) console.log('1613', employees[item]);
                    if (employees[item].supervisorStatus === this.NOT_REPORTED) {
                        if (this.employeesInfo[employees[item].employeeId][1] === true) {
                            if (employees[item].employeeDepartmentId === '') {
                                employees[item].supervisorStatus = this.NOT_APPEAR;
                            } else {
                                if ((this.departmentsInfo[employees[item].employeeDepartmentId] || this.defaultDepartmentInfo)[1] === true) {
                                    employees[item].supervisorStatus = this.NOT_APPEAR;
                                } else {
                                    employees[item].supervisorStatus = this.NOT_APPLY;
                                }
                            }
                        } else {
                            employees[item].supervisorStatus = this.NOT_APPLY;
                        }
                    }
                }

                this.loadCarrierReport(employees, reviewDate);
            } else {
                for (const item in employees) {
                    //if(employees[item].employeeFolio === 8008) console.log('113', employees[item]);
                    if (employees[item].supervisorStatus === this.NOT_REPORTED) {
                        if (this.employeesInfo[employees[item].employeeId][1] === false) {
                            employees[item].supervisorStatus = this.NOT_APPLY;
                        }

                        if (employees[item].employeeDepartmentId !== '') {
                            if ((this.departmentsInfo[employees[item].employeeDepartmentId] || this.defaultDepartmentInfo)[1] === false) {
                                employees[item].supervisorStatus = this.NOT_APPLY;
                            }
                        }
                    }
                }

                this.loadCarrierReport(employees, reviewDate);
            }
        });
    }

    loadCarrierReport(employees, reviewDate) {
        this.gcrbrdSubs = this.carrierReportService.getCarrierReportsByReportDate(reviewDate).subscribe(tempCarrierReports => {
            this.gcrbrdSubs.unsubscribe();
            console.log('Get carrier data');

            this.loadText = 4;

            if (tempCarrierReports.length > 0) {
                for (const idxCr in tempCarrierReports) {
                    //console.log('Report : ' + idxCr);
                    const carrierReportId = tempCarrierReports[idxCr].id$;
                    const carrierReportEmployees = tempCarrierReports[idxCr].employees;
                    const carrierEmployeeId = tempCarrierReports[idxCr].employeeId;

                    for (const idxCre in carrierReportEmployees) {
                        const employeeId = carrierReportEmployees[idxCre].employeeId.toString();

                        if (employees[employeeId] !== undefined) {
                            employees[employeeId].carrierId.push(carrierReportId);
                            employees[employeeId].carrierEmployee.push(carrierEmployeeId);
                            employees[employeeId].carrierStatus = this.IS_OK;
                            employees[employeeId].carrierValue = employees[employeeId].carrierValue +
                                    carrierReportEmployees[idxCre].startTime + ' - ' +
                                    carrierReportEmployees[idxCre].endTime + ' ';
                        }
                    }
                }

                for (const item in employees) {
                    if (employees[item].carrierStatus === this.NOT_REPORTED) {
                        const arriveCarrier = this.employeesArriveCarrier.indexOf(employees[item].employeeId);

                        if (arriveCarrier > -1) {
                            employees[item].carrierStatus = this.NOT_APPEAR;
                        } else {
                            employees[item].carrierStatus = this.NOT_APPLY;
                        }
                    }
                }

                //this.loadPrompterReport(employees, reviewDate);
                this.loadSecurityReport(employees, reviewDate); // New Security Additions
            } else {
                for (const item in employees) {
                    if (employees[item].carrierStatus === this.NOT_REPORTED) {
                        const arriveCarrier = this.employeesArriveCarrier.indexOf(employees[item].employeeId);

                        if (arriveCarrier === -1) {
                            employees[item].carrierStatus = this.NOT_APPLY;
                        }
                    }
                }

                //this.loadPrompterReport(employees, reviewDate);
                this.loadSecurityReport(employees, reviewDate); // New Security Additions
            }
        });
    }

    /* New Security Additions */
    loadSecurityReport(employees, reviewDate) {
        console.log('Get security data', reviewDate, employees);
        window['tmp_employees'] = employees;
        let sub = this.securityReportService.getSecurityReports({equalsDate: reviewDate}).subscribe(reports => {
            console.log('loadSecurityrteport -> ', reports);
            sub.unsubscribe();
            this.loadText = 8;
            if(reports.length){
                for(let report of reports){
                    let { id, employees: reportEmployees, employeeId } = report;
                    for(let employee of reportEmployees){
                        if(employees[employee.id]){
                            employees[employee.id].securityId.push(id);
                            employees[employee.id].securityStatus = this.IS_OK;
                            employees[employee.id].securityValue += `${employee.time} `;
                        }
                    }
                }
                for(let employeeId in employees){
                    const employee = employees[employeeId];
                    if(employee.securityStatus == this.NOT_REPORTED){
                        //if(employee.employeeFolio == 8008) console.log('tmp01', employee);
                        if(this.employeesInfo[employee.employeeId][2]){
                            //if(employee.employeeFolio === 8008) console.log('tmp02', this.employeesInfo[employee.employeeId], this.departmentsInfo[employee.employeeDepartmentId][1], this.defaultDepartmentInfo[1]);
                            if(employee.employeeDepartmentId == '') employee.securityStatus = this.NOT_APPEAR;
                            else employee.securityStatus = ((this.departmentsInfo[employee.employeeDepartmentId] || this.defaultDepartmentInfo)[2]) ? this.NOT_APPEAR : this.NOT_APPLY;
                        }else employee.securityStatus = this.NOT_APPLY;
                    }
                }
                this.loadPrompterReport(employees, reviewDate);
            }else{
                for(let employeeId in employees){
                    const employee = employees[employeeId];
                    //if(employee.employeeFolio === 8008) console.log('tmp03', employee);
                    if(employee.securityStatus === this.NOT_REPORTED){
                        //if(employee.employeeFolio === 8008) console.log('tmp04', this.employeesInfo[employee.employeeId], this.departmentsInfo[employee.employeeDepartmentId][2], this.defaultDepartmentInfo[2]);
                        if(this.employeesInfo[employee.employeeId][2] === false) employee.securityStatus = this.NOT_APPLY;
                        if(employee.employeeDepartmentId !== ''){
                            if ((this.departmentsInfo[employee.employeeDepartmentId] || this.defaultDepartmentInfo)[2] === false) employee.securityStatus = this.NOT_APPLY;
                        }
                    }
                }
                this.loadPrompterReport(employees, reviewDate);
            }
        });
    }

    loadPrompterReport(employees, reviewDate) {
        let reviewDateStr = Utils.stringDate(reviewDate);
        let sub = this.newPrompterReportService.getNewPrompterReports({fromDate: reviewDateStr}).subscribe(reports => {
            sub.unsubscribe();
            this.loadText = 5;
            for(let report of reports){
                for(let reportEmployee of report.employees){
                    let employeeId = reportEmployee.id;
                    if(employees[employeeId]){
                        employees[employeeId].prompterId.push(report.id);
                        employees[employeeId].prompterStatus = this.IS_OK;
                        employees[employeeId].prompterValue += `${reportEmployee.time} `;
                    }
                }
            }
            for (const item in employees) {
                if (employees[item].prompterStatus === this.NOT_REPORTED) {
                    if (this.employeesInfo[employees[item].employeeId][0] === true) {
                        if (employees[item].employeeDepartmentId === '') {
                            employees[item].prompterStatus = this.NOT_APPEAR;
                        } else {
                            if ((this.departmentsInfo[employees[item].employeeDepartmentId] || this.defaultDepartmentInfo)[0] === true) {
                                employees[item].prompterStatus = this.NOT_APPEAR;
                            } else {
                                employees[item].prompterStatus = this.NOT_APPLY;
                            }
                        }
                    } else {
                        employees[item].prompterStatus = this.NOT_APPLY;
                    }
                }
            }
            this.loadApprovedAssistance(employees);
        });
        if(1) return;
        this.gprbrdSubs = this.prompterReportService.getPrompterReportsByReportDate(reviewDate).subscribe(tempPrompterReports => {
            this.gprbrdSubs.unsubscribe();
            console.log('Get prompter data');

            this.loadText = 5;

            //if (tempPrompterReports.length > 0) {
            if (true) {
                for (const idxPr in tempPrompterReports) {
                    //console.log('Report : ' + idxPr);
                    const prompterReportId = tempPrompterReports[idxPr].id$;
                    const prompterReportEmployees = tempPrompterReports[idxPr].employees;

                    for (const idxPre in prompterReportEmployees) {
                        const employeeId = prompterReportEmployees[idxPre].employeeId.toString();

                        if (employees[employeeId] !== undefined) {
                            employees[employeeId].prompterId.push(prompterReportId);
                            employees[employeeId].prompterStatus = this.IS_OK;
                            employees[employeeId].prompterValue = employees[employeeId].prompterValue +
                                    prompterReportEmployees[idxPre].captureTime + ' ';
                        }
                    }
                }

                for (const item in employees) {
                    if (employees[item].prompterStatus === this.NOT_REPORTED) {
                        if (this.employeesInfo[employees[item].employeeId][0] === true) {
                            if (employees[item].employeeDepartmentId === '') {
                                employees[item].prompterStatus = this.NOT_APPEAR;
                            } else {
                                if ((this.departmentsInfo[employees[item].employeeDepartmentId] || this.defaultDepartmentInfo)[0] === true) {
                                    employees[item].prompterStatus = this.NOT_APPEAR;
                                } else {
                                    employees[item].prompterStatus = this.NOT_APPLY;
                                }
                            }
                        } else {
                            employees[item].prompterStatus = this.NOT_APPLY;
                        }
                    }
                }

                this.loadApprovedAssistance(employees);
            } /* else {
                for (const item in employees) {
                    //console.log('______', employees[item]);
                    if (employees[item].prompterStatus === this.NOT_REPORTED) {
                        if (this.employeesInfo[employees[item].employeeId][0] === false) {
                            employees[item].prompterStatus = this.NOT_APPLY;
                        }

                        if (employees[item].employeeDepartmentId !== '') {
                            if (!(this.departmentsInfo[employees[item].employeeDepartmentId] || this.defaultDepartmentInfo)[0] === false) {
                                employees[item].prompterStatus = this.NOT_APPLY;
                            }
                        }
                    }
                }

                this.loadApprovedAssistance(employees);
            } */
        });
    }

    loadApprovedAssistance(employees) {
        console.log('Get approved assistance');

        this.gaabrdSubs = this.approvedAssistanceService.getApprovedAssistancesByReportDate(this._review).subscribe(tempAssistances => {
            this.gaabrdSubs.unsubscribe();

            if (tempAssistances.length > 0) {
                for (const idxA in tempAssistances) {
                    //console.log('Approve Assistance : ' + idxA);
                    const employeeId = tempAssistances[idxA].employeeId.toString();
                    const typeAssistance = tempAssistances[idxA].type;

                    //if(employees[employeeId].employeeFolio === 8008) console.log('114', employees[employeeId]);
                    if (employees[employeeId] !== undefined) {
                        if (typeAssistance === this.TYPE_CHECK_CLOCK) {
                            if (employees[employeeId].checkClockStatus === this.NOT_REPORTED ||
                                                            employees[employeeId].checkClockStatus === this.NOT_APPEAR) {
                                employees[employeeId].checkClockId.push(tempAssistances[idxA].id$);
                                employees[employeeId].checkClockStatus = this.IS_APPROVED;
                                employees[employeeId].checkClockValue = this.IS_APPROVED_TEXT;
                            }
                        } else if (typeAssistance === this.TYPE_SUPERVISOR) {
                            if (employees[employeeId].supervisorStatus === this.NOT_REPORTED ||
                                                            employees[employeeId].supervisorStatus === this.NOT_APPEAR) {
                                employees[employeeId].supervisorId.push(tempAssistances[idxA].id$);
                                employees[employeeId].supervisorStatus = this.IS_APPROVED;
                                employees[employeeId].supervisorValue = this.IS_APPROVED_TEXT;
                            }
                        } else if (typeAssistance === this.TYPE_SECURITY) {
                            if (employees[employeeId].securityStatus === this.NOT_REPORTED ||
                                                            employees[employeeId].securityStatus === this.NOT_APPEAR) {
                                employees[employeeId].securityId.push(tempAssistances[idxA].id$);
                                employees[employeeId].securityStatus = this.IS_APPROVED;
                                employees[employeeId].securityValue = this.IS_APPROVED_TEXT;
                            }
                        } else if (typeAssistance === this.TYPE_CARRIER) {
                        //} else if (Math.floor(typeAssistance) === this.TYPE_CARRIER) {
                            if (employees[employeeId].carrierStatus === this.NOT_REPORTED ||
                                                            employees[employeeId].carrierStatus === this.NOT_APPEAR) {
                                employees[employeeId].carrierId.push(tempAssistances[idxA].id$);
                                employees[employeeId].carrierStatus = this.IS_APPROVED;
                                employees[employeeId].carrierValue = this.IS_APPROVED_TEXT;
                            }
                        } else if (typeAssistance === this.TYPE_PROMPTER) {
                            if (employees[employeeId].prompterStatus === this.NOT_REPORTED ||
                                                            employees[employeeId].prompterStatus === this.NOT_APPEAR) {
                                employees[employeeId].prompterId.push(tempAssistances[idxA].id$);
                                employees[employeeId].prompterStatus = this.IS_APPROVED;
                                employees[employeeId].prompterValue = this.IS_APPROVED_TEXT;
                            }
                        }
                    }
                }

                this.generateAssistanceReport(employees);
            } else {
                this.generateAssistanceReport(employees);
            }
        });
    }

    generateAssistanceReport(employees) {
        console.log('Generating assistance report');

        this.loadText = 6;

        let counter = 0;

        for (const item in employees) {
            if(employees[item].carrierIsForeign) employees[item].carrierStatus = this.NOT_APPLY;
            if (
                (employees[item].checkClockStatus === this.IS_OK || employees[item].checkClockStatus === this.NOT_APPLY || employees[item].checkClockStatus === this.IS_APPROVED) &&
                (employees[item].supervisorStatus === this.IS_OK || employees[item].supervisorStatus === this.NOT_APPLY || employees[item].supervisorStatus === this.IS_APPROVED) &&
                (employees[item].securityStatus === this.IS_OK || employees[item].securityStatus === this.NOT_APPLY || employees[item].securityStatus === this.IS_APPROVED) &&
                (employees[item].carrierStatus === this.IS_OK || employees[item].carrierStatus === this.NOT_APPLY || employees[item].carrierStatus === this.IS_APPROVED) &&
                (employees[item].prompterStatus === this.IS_OK || employees[item].prompterStatus === this.NOT_APPLY || employees[item].prompterStatus === this.IS_APPROVED)
            ) {
                employees[item].status = this.COMPLETE;
            } else {
                employees[item].status = this.INCOMPLETE;
            }

            counter = counter + 1;
        }

        const currentDate = new Date();

        const assistanceReportJson = {
            active: true,
            captureUser: this.userSession['email'],
            createdAt: currentDate,
            generationDate: currentDate,
            reportDate: this._review,
            status: 0, // OPEN
            updatedAt: currentDate
        };

        this.service.postAssistanceReport(this._review, assistanceReportJson).then(responseId => {
            if (responseId !== '') {
                const sizeBatch = 500;
                const numberBatchs = Math.floor(counter / sizeBatch) + (counter % sizeBatch === 0 ? 0 : 1);

                this.processEmployees(this, employees, counter, sizeBatch, numberBatchs, 1, responseId);
            }
        });
    }

    processEmployees(self, employees, totalEmployees, itemsToProcess, totalOfProcess, iProcess, assistanceReportId) {
        console.log('Iteration : ' + iProcess + ' / ' + totalOfProcess);

        if (totalOfProcess === iProcess) {
            const arrayEmployees = Object.values(employees);

            self.service.postAssistanceReportEmployeesAtomic(assistanceReportId, arrayEmployees).then(function() {
                self.getAssistanceReport(assistanceReportId);

                self.createAction = false;
                self.updateAction = true;
            });
        } else {
            const arrayEmployees = Object.values(employees);
            const processingEmployees = arrayEmployees.splice(0, itemsToProcess);
            const remainingEmployees = arrayEmployees.splice(0, (totalEmployees - itemsToProcess));

            self.service.postAssistanceReportEmployeesAtomic(assistanceReportId, processingEmployees).then(function() {
                self.processEmployees(self, remainingEmployees, (totalEmployees - itemsToProcess), itemsToProcess,
                                      totalOfProcess, (iProcess + 1), assistanceReportId);
            });
        }
    }

    getAssistanceReport(assistanceReportId) {
        console.log('Getting assistance report : ' + assistanceReportId);

        this.loadText = 7;

        this.showAssistanceReport = true;

        this.gareSubs = this.service.getAssistanceReportEmployees(assistanceReportId).subscribe(assistanceReportObj => {
            this.gareSubs.unsubscribe();

            this.reportDate = assistanceReportObj[0].reportDate;
            this.captureUser = assistanceReportObj[0].captureUser;
            this.generationDate = Utils.getDateTime(assistanceReportObj[0].generationDate);
            this.employeesData = assistanceReportObj[0].employees;

            this.filterVal = 1;

            this.closedAssistanceReport = (assistanceReportObj[0].status === 1 ? true : false);

            this.displayAssistanceReport();

            console.log('End');
            this.runningFlag = false;
            this.loadText = 0;
        });
    }

    displayAssistanceReport() {
        const employees = this.employeesData;
        const employeesTable = [];

        for (let item in employees) {
            const checkClockDsc = (employees[item].checkClockStatus === this.NOT_REPORTED ? this.NOT_REPORTED_TEXT :
                    employees[item].checkClockStatus === this.NOT_APPEAR ? this.NOT_APPEAR_TEXT :
                    employees[item].checkClockStatus === this.NOT_APPLY ? this.NOT_APPLY_TEXT :
                    employees[item].checkClockStatus === this.IS_APPROVED ? this.IS_APPROVED_TEXT : employees[item].checkClockValue);

            const supervisorDsc = (employees[item].supervisorStatus === this.NOT_REPORTED ? this.NOT_REPORTED_TEXT :
                    employees[item].supervisorStatus === this.NOT_APPEAR ? this.NOT_APPEAR_TEXT :
                    employees[item].supervisorStatus === this.NOT_APPLY ? this.NOT_APPLY_TEXT :
                    employees[item].supervisorStatus === this.IS_APPROVED ? this.IS_APPROVED_TEXT : employees[item].supervisorValue);

            const securityDsc = (employees[item].securityStatus === this.NOT_REPORTED ? this.NOT_REPORTED_TEXT :
                    employees[item].securityStatus === this.NOT_APPEAR ? this.NOT_APPEAR_TEXT :
                    employees[item].securityStatus === this.NOT_APPLY ? this.NOT_APPLY_TEXT :
                    employees[item].securityStatus === this.IS_APPROVED ? this.IS_APPROVED_TEXT : employees[item].securityValue);
            //if(employees[item].employeeFolio == 8008) console.log('115', employees[item]);

            const carrierDsc = (employees[item].carrierStatus === this.NOT_REPORTED ? this.NOT_REPORTED_TEXT :
                    employees[item].carrierStatus === this.NOT_APPEAR ? this.NOT_APPEAR_TEXT :
                    employees[item].carrierStatus === this.NOT_APPLY ? this.NOT_APPLY_TEXT :
                    employees[item].carrierStatus === this.IS_APPROVED ? this.IS_APPROVED_TEXT : employees[item].carrierValue);

            const prompterDsc = (employees[item].prompterStatus === this.NOT_REPORTED ? this.NOT_REPORTED_TEXT :
                    employees[item].prompterStatus === this.NOT_APPEAR ? this.NOT_APPEAR_TEXT :
                    employees[item].prompterStatus === this.NOT_APPLY ? this.NOT_APPLY_TEXT :
                    employees[item].prompterStatus === this.IS_APPROVED ? this.IS_APPROVED_TEXT : employees[item].prompterValue);

            const action = (this.closedAssistanceReport === true ? '' : employees[item].status === this.COMPLETE ? ' - ' : 'Revisar');

            const icon = (employees[item].status === this.COMPLETE ?
                    '<i class = "small material-icons" style = "color: #558b2f;">done</i>' :
                    '<i class = "small material-icons" style = "color: #ef6c00;">clear</i>');

            const employee = {
                actionGroup: '<button style="pointer-events: none;" class="btn-floating btn waves-effect light-blue lighten-1"><i class="material-icons">account_box</i></button>',
                employeeId: employees[item].employeeId,
                employeeName: employees[item].employeeName,
                employeeFolio: employees[item].employeeFolio,
                checkClock: checkClockDsc,
                supervisor: supervisorDsc,
                security: securityDsc,
                carrier: carrierDsc,
                prompter: prompterDsc,
                name: action,
                icon: icon,
                checkClockStatus: employees[item].checkClockStatus,
                supervisorStatus: employees[item].supervisorStatus,
                securityStatus: employees[item].securityStatus,
                carrierStatus: employees[item].carrierStatus,
                prompterStatus: employees[item].prompterStatus,
                status: employees[item].status
            };

            if (this.filterVal === 0) {
                if (employee.checkClockStatus > 0 || employee.supervisorStatus > 0 || employee.securityStatus > 0 ||
                                employee.prompterStatus > 0 || employee.carrierStatus > 0 ||
                                employees[item].status === this.COMPLETE) {
                    employeesTable.push(employee);
                }
            } else if (this.filterVal === 1 && employees[item].status === this.INCOMPLETE) {
                if (employee.checkClockStatus > 0 || employee.supervisorStatus > 0 || employee.securityStatus > 0 ||
                                employee.prompterStatus > 0 || employee.carrierStatus > 0) {
                    employeesTable.push(employee);
                }
            } else if (this.filterVal === 2 && employees[item].status === this.COMPLETE) {
                employeesTable.push(employee);
            } else if (this.filterVal === 3 && employees[item].status === this.INCOMPLETE) {
                if (employee.checkClockStatus <= 0 && employee.supervisorStatus <= 0 && employee.securityStatus <= 0 &&
                                employee.prompterStatus <= 0 && employee.carrierStatus <= 0) {
                    employeesTable.push(employee);
                }
            }
        }

        this.data = employeesTable;
        console.log(this.data)
        this.length = this.data.length;
        this.onChangeTable(this.config);
    }

    radioChange() {
        this.data = [];
        this.length = this.data.length;
        this.onChangeTable(this.config);

        this.displayAssistanceReport();
    }

    onCellClick(data: any): any {
        if (data.column === 'actionGroup') {
            this.onInfo(data);
            return;
        }

        this.employeeIdOnModal = data.row.employeeId;
        if (data.row.status === this.INCOMPLETE && this.closedAssistanceReport === false) {
            this.inconsistency = data.row;

            this.reportDateCcVal = this._review;
            this.employeeNameCcVal = data.row.employeeName;
            this.userNameCcVal = this.userSession['email'];
            this.isCheckClockPending = (data.row.checkClockStatus !== this.IS_OK && data.row.checkClockStatus !== this.NOT_APPLY && data.row.checkClockStatus !== this.IS_APPROVED);

            this.reportDateSupVal = this._review;
            this.employeeNameSupVal = data.row.employeeName;
            this.userNameSupVal = this.userSession['email'];
            this.isSupervisorPending = (data.row.supervisorStatus !== this.IS_OK && data.row.supervisorStatus !== this.NOT_APPLY && data.row.supervisorStatus !== this.IS_APPROVED);

            this.reportDateSecVal = this._review;
            this.employeeNameSecVal = data.row.employeeName;
            this.userNameSecVal = this.userSession['email'];
            this.isSecurityPending = (data.row.securityStatus !== this.IS_OK && data.row.securityStatus !== this.NOT_APPLY && data.row.securityStatus !== this.IS_APPROVED);

            this.reportDateCarVal = this._review;
            this.employeeNameCarVal = data.row.employeeName;
            this.userNameCarVal = this.userSession['email'];
            this.isCarrierPending = (data.row.carrierStatus !== this.IS_OK && data.row.carrierStatus !== this.NOT_APPLY && data.row.carrierStatus !== this.IS_APPROVED);

            this.reportDatePromVal = this._review;
            this.employeeNamePromVal = data.row.employeeName;
            this.userNamePromVal = this.userSession['email'];
            this.isPrompterPending = (data.row.prompterStatus !== this.IS_OK && data.row.prompterStatus !== this.NOT_APPLY && data.row.prompterStatus !== this.IS_APPROVED);

            this.openModal();
        }
    }

    employeeIdOnModal: string = '';
    onNoWork(){

        this.service.putAssistanceReportEmployee(this.review,{
            checkClockStatus: -1,
            supervisorStatus: -1,
            securityStatus: -1,
            prompterStatus: -1,
            carrierStatus: -1,
        }, this.employeeIdOnModal);
        this.closeModal();
        toast('Se pasó el empleado');
        this.getAssistanceReport(this.review);
    }

    openModal() {
        this.modalActions.emit({ action: 'modal', params: ['open'] });
    }

    closeModal() {
        this.reportDateCcVal = '';
        this.employeeNameCcVal = '';
        this.userNameCcVal = '';

        this.reportDateSupVal = '';
        this.employeeNameSupVal = '';
        this.userNameSupVal = '';

        this.reportDateSecVal = '';
        this.employeeNameSecVal = '';
        this.userNameSecVal = '';

        this.reportDateCarVal = '';
        this.employeeNameCarVal = '';
        this.userNameCarVal = '';

        this.reportDatePromVal = '';
        this.employeeNamePromVal = '';
        this.userNamePromVal = '';

        this.isCheckClockPending = false;
        this.isSupervisorPending = false;
        this.isSecurityPending = false;
        this.isCarrierPending = false;
        this.isPrompterPending = false;

        this.modalActions.emit({ action: 'modal', params: ['close'] });
    }

    onSubmitCheckClockApprove() {
        this.saveApproveAssistence(this.TYPE_CHECK_CLOCK, this.reportDateCcVal, this.userNameCcVal, this.employeeNameCcVal);
    }

    onSubmitSupervisorApprove() {
        this.saveApproveAssistence(this.TYPE_SUPERVISOR, this.reportDateSupVal, this.userNameSupVal, this.employeeNameSupVal);
    }

    onSubmitSecurityApprove() {
        this.saveApproveAssistence(this.TYPE_SECURITY, this.reportDateSecVal, this.userNameSecVal, this.employeeNameSecVal);
    }

    onSubmitCarrierApprove() {
        this.saveApproveAssistence(this.TYPE_CARRIER, this.reportDateCarVal, this.userNameCarVal, this.employeeNameCarVal);
    }

    onSubmitPrompterApprove() {
        this.saveApproveAssistence(this.TYPE_PROMPTER, this.reportDatePromVal, this.userNamePromVal, this.employeeNamePromVal);
    }

    saveApproveAssistence(type, assistanceReport, user, employeeName, reload: boolean = true): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            const currentDate = new Date();

            const approveJson = {
                active: true,
                approbationDate: currentDate,
                assistanceReportId: assistanceReport,
                captureUser: user,
                createdAt: currentDate,
                employeeId: this.inconsistency.employeeId,
                updatedAt: currentDate,
                type: type
            };

            this.approvedAssistanceService.postApprovedAssistance(approveJson).then(resId => {
                const employeeData = this.employeesData.find(i => i.employeeId === approveJson.employeeId);

                let updateStatus = this.INCOMPLETE;

                let employeeJson: any;

                if (type === this.TYPE_CHECK_CLOCK) {
                    employeeData.checkClockStatus = this.IS_APPROVED;
                    if ((employeeData.supervisorStatus === this.IS_OK || employeeData.supervisorStatus === this.NOT_APPLY ||
                         employeeData.supervisorStatus === this.IS_APPROVED) &&
                        (employeeData.securityStatus === this.IS_OK || employeeData.securityStatus === this.NOT_APPLY ||
                         employeeData.securityStatus === this.IS_APPROVED) &&
                        (employeeData.carrierStatus === this.IS_OK || employeeData.carrierStatus === this.NOT_APPLY ||
                         employeeData.carrierStatus === this.IS_APPROVED) &&
                        (employeeData.prompterStatus === this.IS_OK || employeeData.prompterStatus === this.NOT_APPLY ||
                         employeeData.prompterStatus === this.IS_APPROVED)) {
                        updateStatus = this.COMPLETE;
                    }
                    employeeData.status = updateStatus;

                    employeeJson = {
                        checkClockId: [],
                        checkClockStatus: this.IS_APPROVED,
                        checkClockValue: this.IS_APPROVED_TEXT,
                        status: updateStatus
                    };
                    employeeJson.checkClockId.push(resId);
                } else if (type === this.TYPE_SUPERVISOR) {
                    employeeData.supervisorStatus = this.IS_APPROVED;
                    if ((employeeData.checkClockStatus === this.IS_OK || employeeData.checkClockStatus === this.NOT_APPLY ||
                         employeeData.checkClockStatus === this.IS_APPROVED) &&
                        (employeeData.securityStatus === this.IS_OK || employeeData.securityStatus === this.NOT_APPLY ||
                         employeeData.securityStatus === this.IS_APPROVED) &&
                        (employeeData.carrierStatus === this.IS_OK || employeeData.carrierStatus === this.NOT_APPLY ||
                         employeeData.carrierStatus === this.IS_APPROVED) &&
                        (employeeData.prompterStatus === this.IS_OK || employeeData.prompterStatus === this.NOT_APPLY ||
                         employeeData.prompterStatus === this.IS_APPROVED)) {
                        updateStatus = this.COMPLETE;
                    }
                    employeeData.status = updateStatus;

                    employeeJson = {
                        supervisorId: [],
                        supervisorStatus: this.IS_APPROVED,
                        supervisorValue: this.IS_APPROVED_TEXT,
                        status: updateStatus
                    };
                    employeeJson.supervisorId.push(resId);
                } else if (type === this.TYPE_SECURITY) {
                    employeeData.securityStatus = this.IS_APPROVED;
                    if ((employeeData.checkClockStatus === this.IS_OK || employeeData.checkClockStatus === this.NOT_APPLY ||
                         employeeData.checkClockStatus === this.IS_APPROVED) &&
                        (employeeData.supervisorStatus === this.IS_OK || employeeData.supervisorStatus === this.NOT_APPLY ||
                         employeeData.supervisorStatus === this.IS_APPROVED) &&
                        (employeeData.carrierStatus === this.IS_OK || employeeData.carrierStatus === this.NOT_APPLY ||
                         employeeData.carrierStatus === this.IS_APPROVED) &&
                        (employeeData.prompterStatus === this.IS_OK || employeeData.prompterStatus === this.NOT_APPLY ||
                         employeeData.prompterStatus === this.IS_APPROVED)) {
                        updateStatus = this.COMPLETE;
                    }
                    employeeData.status = updateStatus;

                    employeeJson = {
                        securityId: [],
                        securityStatus: this.IS_APPROVED,
                        securityValue: this.IS_APPROVED_TEXT,
                        status: updateStatus
                    };
                    employeeJson.securityId.push(resId);
                //} else if (Math.floor(type) === this.TYPE_CARRIER) {
                } else if (type === this.TYPE_CARRIER) {
                    employeeData.carrierStatus = this.IS_APPROVED;
                    if ((employeeData.checkClockStatus === this.IS_OK || employeeData.checkClockStatus === this.NOT_APPLY ||
                         employeeData.checkClockStatus === this.IS_APPROVED) &&
                        (employeeData.supervisorStatus === this.IS_OK || employeeData.supervisorStatus === this.NOT_APPLY ||
                         employeeData.supervisorStatus === this.IS_APPROVED) &&
                        (employeeData.securityStatus === this.IS_OK || employeeData.securityStatus === this.NOT_APPLY ||
                         employeeData.securityStatus === this.IS_APPROVED) &&
                        (employeeData.prompterStatus === this.IS_OK || employeeData.prompterStatus === this.NOT_APPLY ||
                         employeeData.prompterStatus === this.IS_APPROVED)) {
                        updateStatus = this.COMPLETE;
                    }
                    employeeData.status = updateStatus;

                    employeeJson = {
                        carrierId: [],
                        carrierEmployee: [],
                        carrierStatus: this.IS_APPROVED,
                        carrierValue: this.IS_APPROVED_TEXT,
                        status: updateStatus
                    };
                    employeeJson.carrierId.push(resId);
                } else if (type === this.TYPE_PROMPTER) {
                    employeeData.prompterStatus = this.IS_APPROVED;
                    if ((employeeData.checkClockStatus === this.IS_OK || employeeData.checkClockStatus === this.NOT_APPLY ||
                         employeeData.checkClockStatus === this.IS_APPROVED) &&
                        (employeeData.supervisorStatus === this.IS_OK || employeeData.supervisorStatus === this.NOT_APPLY ||
                         employeeData.supervisorStatus === this.IS_APPROVED) &&
                        (employeeData.securityStatus === this.IS_OK || employeeData.securityStatus === this.NOT_APPLY ||
                         employeeData.securityStatus === this.IS_APPROVED) &&
                        (employeeData.carrierStatus === this.IS_OK || employeeData.carrierStatus === this.NOT_APPLY ||
                         employeeData.carrierStatus === this.IS_APPROVED)) {
                        updateStatus = this.COMPLETE;
                    }
                    employeeData.status = updateStatus;

                    employeeJson = {
                        prompterId: [],
                        prompterStatus: this.IS_APPROVED,
                        prompterValue: this.IS_APPROVED_TEXT,
                        status: updateStatus
                    };
                    employeeJson.prompterId.push(resId);
                }

                this.service.putAssistanceReportEmployee(approveJson.assistanceReportId,
                                                                         employeeJson, approveJson.employeeId).then(res => {
                    let typeText: string;

                    if (type === this.TYPE_CHECK_CLOCK) {
                        typeText = 'Reloj Checador';
                    } else if (type === this.TYPE_SUPERVISOR) {
                        typeText = 'Reporte de Supervisor';
                    } else if (type === this.TYPE_SECURITY) {
                        typeText = 'Reporte de Seguridad';
                    } else if (Math.floor(type) === this.TYPE_CARRIER) {
                        typeText = 'Reporte de Transportista';
                    } else if (type === this.TYPE_PROMPTER) {
                        typeText = 'Reporte de Apuntador';
                    }

                    const logJson = {
                        actionDate: approveJson.createdAt,
                        actionDescription: 'El usuario ' + approveJson.captureUser +
                                          ' aprobó la inconsistencia para el empleado ' + employeeName +
                                          ' en el ' + typeText + ' para el día ' + approveJson.assistanceReportId,
                        employeeId: approveJson.employeeId,
                        userId: approveJson.captureUser,
                        objectId: resId,
                        objectDescription: 'Aprobación Inconsistencia de Asistencia - ' + typeText
                    };

                    this.logService.postLog(logJson).then(resp => {
                        if (type === this.TYPE_CHECK_CLOCK) {
                            this.isCheckClockPending = false;
                        } else if (type === this.TYPE_SUPERVISOR) {
                            this.isSupervisorPending = false;
                        } else if (type === this.TYPE_SECURITY) {
                            this.isSecurityPending = false;
                        } else if (Math.floor(type) === this.TYPE_CARRIER || type === this.TYPE_CARRIER) {
                            this.isCarrierPending = false;
                        } else if (type === this.TYPE_PROMPTER) {
                            this.isPrompterPending = false;
                        }

                        if (reload) {
                            this.data = [];
                            this.length = this.data.length;
                            this.onChangeTable(this.config);

                            this.reportDate = '';
                            this.captureUser = '';
                            this.generationDate = '';
                            this.employeesData = [];

                            //this.closeModal();
                            //this.openModal();

                            this.getAssistanceReport(this._review);
                        }

                        if (!this.isCheckClockPending && !this.isSupervisorPending && !this.isSecurityPending && !this.isCarrierPending && !this.isPrompterPending) {
                            toast('Se han aprobado todas las inconsistencias.', 3000);
                            this.closeModal();
                        }

                        resolve();
                    }).catch(err => {
                        console.error('Error in postLog', err);
                        resolve();
                    });
                }).catch(err => {
                    console.error('Error in putAssistanceReportEmployee', err);
                    reject(err);
                });
            }).catch(err => {
                console.error('Error in postApprovedAssistance', err);
                reject(err);
            });
        });
    }

    async onApproveAll() {
        const approveTasks = [];
        
        if (this.isCheckClockPending) {
            approveTasks.push({ type: this.TYPE_CHECK_CLOCK, date: this.reportDateCcVal, user: this.userNameCcVal, name: this.employeeNameCcVal });
        }
        if (this.isSupervisorPending) {
            approveTasks.push({ type: this.TYPE_SUPERVISOR, date: this.reportDateSupVal, user: this.userNameSupVal, name: this.employeeNameSupVal });
        }
        if (this.isSecurityPending) {
            approveTasks.push({ type: this.TYPE_SECURITY, date: this.reportDateSecVal, user: this.userNameSecVal, name: this.employeeNameSecVal });
        }
        if (this.isCarrierPending) {
            approveTasks.push({ type: this.TYPE_CARRIER, date: this.reportDateCarVal, user: this.userNameCarVal, name: this.employeeNameCarVal });
        }
        if (this.isPrompterPending) {
            approveTasks.push({ type: this.TYPE_PROMPTER, date: this.reportDatePromVal, user: this.userNamePromVal, name: this.employeeNamePromVal });
        }

        if (approveTasks.length > 0) {
            for (let i = 0; i < approveTasks.length; i++) {
                const isLast = (i === approveTasks.length - 1);
                const task = approveTasks[i];
                await this.saveApproveAssistence(task.type, task.date, task.user, task.name, isLast);
            }
            this.closeModal();
        }
    }

    onInfo(data: any) {
        this.igeSubs = this.employeeService.getEmployeeData(data.row.employeeId).subscribe(employeeObj => {
            this.igeSubs.unsubscribe();

            this.employeeInfo.name = `${data.row.employeeName}`;
            this.employeeInfo.jobName = employeeObj[0].jobObj.jobName;
            this.employeeInfo.baseSalary = employeeObj[0].jobObj.baseSalary;

            if (employeeObj[0].departmentId) {
                this.igdSubs = this.departmentService.getDepartment(employeeObj[0].departmentId).subscribe(departmentObj => {
                    this.igdSubs.unsubscribe();

                    this.employeeInfo.departmentName = departmentObj.name;
                });
            }

            this.employeeInfo.transportArrive = employeeObj[0].transportArrive;

            if (Math.floor(employeeObj[0].transportArrive) !== 3) {
                switch (employeeObj[0].transportArrive) {
                    case 1:
                        this.employeeInfo.transportArriveName = 'Por su propio medio';
                        break;
                    case 2:
                        this.employeeInfo.transportArriveName = 'Duerme en las instalaciones';
                        break;
                    case 4:
                        this.employeeInfo.transportArriveName = 'Transporte de la empresa';
                        break;
                    default:
                        this.employeeInfo.transportArriveName = 'No especificado';
                        break;
                }
            } else {
                this.igcSubs = this.employeeService.getEmployee(employeeObj[0].carrierId).subscribe(carrierObj => {
                    this.igcSubs.unsubscribe();

                    this.employeeInfo.transportArriveName = employeeObj[0].transportArrive == 3 ? 'Es trasladado por un transportista local' : 'Es transladado por un transportista foráneo';
                    this.employeeInfo.carrierName = carrierObj.name + ' ' + carrierObj.lastName;
                });
            }

            this.openInfoModal();
        });
    }

    openInfoModal() {
        this.infoModalActions.emit({ action: 'modal', params: ['open'] });
    }

    closeInfoModal() {
        this.employeeInfo = [];

        this.infoModalActions.emit({ action: 'modal', params: ['close'] });
    }



    // *************** Table functionality *************** //
    changePage(page: any, data: Array<any> = this.data): Array<any> {
        let start = (page.page - 1) * page.itemsPerPage;
        let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

        return data.slice(start, end);
    }

    changeSort(data: any, config: any): any {
        if (!config.sorting) {
            return data;
        }

        let columns = this.config.sorting.columns;
        let columnName: string;
        let sort: string;

        for (let i = 0; i < columns.length; i++) {
            if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
                columnName = columns[i].name;
                sort = columns[i].sort;
            }
        }

        if (!columnName) {
            return data;
        }

        // simple sorting
        return data.sort((previous: any, current: any) => {
            if (previous[columnName] > current[columnName]) {
                return sort === 'desc' ? -1 : 1;
            } else if (previous[columnName] < current[columnName]) {
                return sort === 'asc' ? -1 : 1;
            }

            return 0;
        });
    }

    changeFilter(data: any, config: any): any {
        let filteredData: Array<any> = data;

        this.columns.forEach((column: any) => {
            if (column.filtering) {
                filteredData = filteredData.filter((item: any) => {
                    return item[column.name].match(column.filtering.filterString);
                });
            }
        });

        if (!config.filtering) {
            return filteredData;
        }

        if (config.filtering.columnName) {
            return filteredData.filter((item: any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
        }

        let tempArray: Array<any> = [];

        filteredData.forEach((item: any) => {
            let flag = false;

            this.columns.forEach((column: any) => {
                if (item[column.name] &&
                    item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
                    flag = true;
                }
            });

            if (flag) {
                tempArray.push(item);
            }
        });

        filteredData = tempArray;

        return filteredData;
    }

    onChangeTable(config: any, page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
        if (config.filtering) {
            Object.assign(this.config.filtering, config.filtering);
        }

        if (config.sorting) {
            Object.assign(this.config.sorting, config.sorting);
        }

        let filteredData = this.changeFilter(this.data, this.config);
        let sortedData = this.changeSort(filteredData, this.config);

        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        this.length = sortedData.length;
    }

}

